import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, loadStoredMember, storeMember } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Tiers } from "@/components/site/Tiers";
import { JoinSection } from "@/components/site/JoinSection";
import { Gift } from "@/components/site/Gift";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [member, setMember] = useState(null);
  const [giftIntent, setGiftIntent] = useState(false);
  const [upgrading, setUpgrading] = useState(false);

  useEffect(() => {
    const stored = loadStoredMember();
    if (!stored?.email) return;
    setMember(stored);
    api.get(`/members/${encodeURIComponent(stored.email)}`)
      .then((res) => {
        storeMember(res.data);
        setMember(res.data);
      })
      .catch(() => {});
  }, []);

  const scrollToJoin = () => document.getElementById("join")?.scrollIntoView({ behavior: "smooth" });

  const onGift = () => {
    setGiftIntent(true);
    scrollToJoin();
    toast("Gift mode on — tick the box in the form and they're in.");
  };

  const onUpgrade = async () => {
    if (!member) return scrollToJoin();
    setUpgrading(true);
    try {
      const res = await api.post("/payments/paypal/subscribe", {
        email: member.email,
        origin_url: window.location.origin,
      });
      window.location.href = res.data.approval_url;
    } catch (err) {
      const status = err.response?.status;
      if (status === 503) {
        toast.error("Premium checkout is being switched on — check back very soon.");
      } else {
        toast.error(err.response?.data?.detail || "Could not open checkout. Try again.");
      }
      setUpgrading(false);
    }
  };

  return (
    <main>
      <Header member={member} />
      <Hero onJoin={scrollToJoin} />
      <EditorialMarquee />
      <Manifesto />
      <Tiers onJoin={scrollToJoin} member={member} onUpgrade={onUpgrade} upgrading={upgrading} />
      <JoinSection
        member={member}
        setMember={setMember}
        giftIntent={giftIntent}
        setGiftIntent={setGiftIntent}
        onUpgrade={onUpgrade}
        upgrading={upgrading}
      />
      <Gift onGift={onGift} />
      <Footer />
    </main>
  );
}
